/**
 * @param {unknown} a
 * @param {unknown} b
 */
export function scalarEqualsSnapshot(a, b) {
  const na = a == null ? '' : String(a).trim();
  const nb = b == null ? '' : String(b).trim();
  if (na.length === 10 && nb.length >= 8 && /^\d{4}-\d{2}-\d{2}/.test(na)) {
    return na.slice(0, 10) === nb.slice(0, 10);
  }
  return na === nb;
}

/**
 * Working copy of server `populated` for controlled inputs.
 * @param {object} p
 */
export function clonePopulated(p) {
  const src = p || {};
  return {
    applicantInfo: { ...(src.applicantInfo || {}) },
    licenseInfo: { ...(src.licenseInfo || {}) },
    qualifications: {
      education: Array.isArray(src.qualifications?.education)
        ? src.qualifications.education.map((e) => ({ ...e }))
        : [],
      experience:
        src.qualifications?.experience != null
          ? { ...src.qualifications.experience }
          : null,
    },
    meta: { ...(src.meta || {}) },
  };
}

/**
 * Baseline for prefilled highlighting: prefer API `initialSnapshot`, else first populated.
 * @param {object|null} initialSnapshot
 * @param {object} populated
 */
export function buildApplicantBaseline(initialSnapshot, populated) {
  const fromInit = initialSnapshot?.applicantInfo;
  if (fromInit && typeof fromInit === 'object') {
    return { ...fromInit };
  }
  return { ...(populated?.applicantInfo || {}) };
}

export function buildLicenseBaseline(initialSnapshot, populated) {
  const fromInit = initialSnapshot?.licenseInfo;
  if (fromInit && typeof fromInit === 'object') {
    return { ...fromInit };
  }
  return { ...(populated?.licenseInfo || {}) };
}

export function buildExperienceBaseline(initialSnapshot, populated) {
  const fromInit = initialSnapshot?.qualifications?.experience;
  if (fromInit && typeof fromInit === 'object') {
    return { ...fromInit };
  }
  const ex = populated?.qualifications?.experience;
  return ex && typeof ex === 'object' ? { ...ex } : {};
}
